import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { OnboardingTopicCompetenciesModalComponent } from 'src/app/private/shared/components/modals/onboarding-topic-competencies-modal/onboarding-topic-competencies-modal.component';
import { TopicBuilderService } from 'src/app/private/shared/services/topic-builder/topic-builder.service';
import { CompetencyBuilderStandardAPIResponse } from 'src/app/private/shared/types/responses/competency-builder.responses';
import { TopicSearchParams } from '../../topics-page/topics-page-helpers';

@Component({
  selector: 'app-onboarding-topics-page',
  templateUrl: './onboarding-topics-page.component.html',
  styleUrl: './onboarding-topics-page.component.scss',
  standalone: false,
})
export class OnboardingTopicsPageComponent implements OnInit {
  @ViewChild('competencyModal')
  competencyModal: OnboardingTopicCompetenciesModalComponent;

  subs: Subscription[] = [];

  topicsTableIsLoading: boolean;

  loadingIcons = true;

  tableData: CompetencyBuilderStandardAPIResponse[];

  searchParams: TopicSearchParams = {
    search: '',
    page: 1,
    sort_by: '',
    sort_by_desc: false,
    districts: [],
  };

  searchTerm: string;

  searchTimeout: ReturnType<typeof setTimeout>;

  topicsListMeta: PaginationDTO;

  selectedTopic: CompetencyBuilderStandardAPIResponse;

  selectedTopicId: number;

  selectedTopicTitle: string;

  constructor(private topicBuilderService: TopicBuilderService) {}

  ngOnInit(): void {
    this.getTopics();
  }

  getTopics() {
    this.topicsTableIsLoading = true;
    this.searchParams.search = this.searchTerm ? this.searchTerm : '';
    this.topicBuilderService
      .getTopicBuilderTopics(this.searchParams)
      .subscribe((res) => {
        if (res.items) {
          this.tableData = res.items;
          this.topicsListMeta = res._meta;
          this.topicsTableIsLoading = false;
        }
      });
  }

  searchTermChanged(event: Event) {
    this.searchTerm = (<HTMLInputElement>event.target).value;
    this.searchTopicsDebounce();
  }

  searchTopicsDebounce() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.searchParams.page = 1;
      this.getTopics();
    }, 300);
  }

  outputChanges(pageNumber?: number) {
    this.searchParams = pageNumber
      ? {
          ...this.searchParams,
          page: pageNumber,
        }
      : this.searchParams;

    this.getTopics();
  }

  previewTopic(topic: CompetencyBuilderStandardAPIResponse) {
    this.competencyModal.topic = topic;
    this.selectedTopic = topic;
    this.competencyModal.openModal();
  }
}
